import { DefaultError, QueryClient, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: string;
  title: string;
  field_page_banner_image: string;
  field_page_title_en: string;
  field_page_title_ms: string;
  field_page_title_zh: string;
  field_page_description_en: string;
  field_page_description_ms: string;
  field_page_description_zh: string;
}

const fetchFlightHeadingDetails = async (airport: string | null): Promise<DocumentDetailsResponse> => {
  if (!airport) throw new Error("Airport not found");
  const response = await passengerCMSApi.get(
    `/api/page-headers/all-fields?pageName=flight-information&airport=${airport}`
  );

  return response.data[0];
};

const useFlightHeadingDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  const [currentAirport] = useLocalStorage("currentAirport", null);
  return useQuery<DocumentDetailsResponse, DefaultError>(
    {
      queryKey: ["FlightHeadingDocumentDetails", id, currentAirport],
      enabled: !!id && !!currentAirport,
      queryFn: () => fetchFlightHeadingDetails(currentAirport),
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useFlightHeadingDocumentDetails };
